import React from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import { Link } from "react-router-dom";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRemoveBranchServiceMutation } from "store/services/branchApi";
import { toast } from "react-toastify";
import { useAuth } from "hooks";

const ServiceCard = ({ services = [], branchDetail, isBusy }) => {
  console.log("Raw services in ServiceCard:", services);
  const validServices = services.filter((service) => service?.name);
  console.log("Valid services:", validServices);

  const [removeService, { isLoading: removingService }] =
    useRemoveBranchServiceMutation();

  const handleRemoveService = async (serviceId) => {
    try {
      await removeService({
        branchId: branchDetail?._id,
        serviceId,
      }).unwrap();
      toast.success("Service removed successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't remove Service!"
      );
    }
  };
  const { isAdmin } = useAuth()
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      {validServices.length > 0 ? (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full">
          {validServices.map((service) => (
            <div key={service._id} className="group">
              <Card
                className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2, position: "relative" }}>
                  <Link to={`/app/crm/service/${service._id}/detail`}>
                    <div className="flex items-center gap-3">
                      <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                        <SupportAgentIcon
                          sx={{
                            fontSize: 20,
                            color: "primary.main",
                          }}
                        />
                      </div>
                      <Typography
                        variant="body2"
                        className="line-clamp-2 font-medium"
                      >
                        {service.name}
                      </Typography>
                    </div>
                  </Link>
                  {isAdmin & (<Tooltip title="Remove Service" arrow>
                    <IconButton
                      size="small"
                      color="error"
                      sx={{
                        position: "absolute",
                        top: 6,
                        right: 4,
                      }}
                      onClick={() => handleRemoveService(service._id)}
                      disabled={isBusy || removingService}
                    >
                      <DeleteIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>)}
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      ) : (
        <EmptyResult height={150} />
      )}
    </Box>
  );
};

export default ServiceCard;